import React from 'react'
import styled from 'styled-components'
import { Container, Fonts, Icon } from 'components/base-ui'
import { weight } from 'components/base-ui/Fonts'
import media from 'styles/media'
import shadow from 'styles/shadow'

export const ReadMore = styled.span`
  font-weight: ${Fonts.weight.medium};
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.green500};
`

export const Cover = styled.div<{ isListScheduleContentMode: boolean }>`
  display: flex;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  ${({ isListScheduleContentMode, theme }) =>
    isListScheduleContentMode
      ? `
    z-index: 2;
    flex-direction: column;
  `
      : `
    align-items: flex-end;
    height: 245px;
  `}

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 30%;
    right: 0;
    bottom: -1px;
    left: 0;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 40%, rgba(255, 255, 255, 0) 100%);
  }

  ${Container} {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing.XL};
  }
`

export const StoreLogo = styled.div`
  margin-right: ${({ theme }) => theme.spacing.L};
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.element.white};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
`

export const StoreDes = styled.div`
  position: relative;
`

export const StoreName = styled.div`
  font-size: 28px;
  font-weight: ${weight.semiBold};
  color: ${({ theme }) => theme.colors.element.black};
  line-height: 1.2em;
  margin-bottom: ${({ theme }) => theme.spacing['4XS']};
`

export const StoreLocationAndTime = styled(Fonts.BaseBold)`
  color: ${({ theme }) => theme.colors.success};
`

export const ButtonOpenSearchNearestLocation = styled(Fonts.LinkSmall)`
  position: absolute;
  left: 0;
  top: 100%;
  color: ${({ theme }) => theme.colors.infoDark};
`

export const StoreLocationName = styled.span`
  color: ${({ theme }) => theme.colors.base};
`

export const BtnAddToCartCoverWrapper = styled.div`
  position: relative;
  top: -${({ theme }) => theme.spacing['3XS']};
  left: ${({ theme }) => theme.spacing['2XS']};
  margin-left: auto;
`

export const BtnAddToCartWrapperSticky = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing.L};

  top: ${({ theme }) => theme.spacing['9XL']};
  transform: translate3d(0, -48px, 0);
  opacity: 0;
  transition: 0.3s;
`

export const MenuContainer = styled(Container)`
  opacity: 1;

  .scrollmagic-pin-spacer {
    width: calc(100% + 44px) !important;
  }
`

export const Navs = styled.div<{ isSticky: boolean }>`
  position: relative;
  margin-left: -${({ theme }) => theme.spacing['4XL']};
  white-space: nowrap;
  background-color: ${({ theme }) => theme.colors.element.white};
  z-index: 99;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.06);

  .scrollbar-track {
    display: none !important;
  }

  ${({ isSticky, theme }) =>
    isSticky
      ? `
    margin-left: -${theme.spacing['4XL']};
  `
      : ''}

  &.-sticky {
    ${BtnAddToCartWrapperSticky} {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }

    @media (${media.screenMdMin}) {
      left: -${({ theme }) => theme.spacing['3XS']} !important;
    }
  }
`

export const Nav = styled.div<{ isActive: boolean }>`
  margin-left: ${({ theme }) => theme.spacing.S};
  margin-right: ${({ theme }) => theme.spacing.S};
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 38px;
  font-weight: ${weight.medium};
  font-size: ${({ theme }) => theme.fontSize.xl};
  color: ${({ theme }) => theme.colors.secondary};

  &:first-child {
    margin-left: ${({ theme }) => theme.spacing['4XL']};
  }

  &:last-child {
    margin-right: ${({ theme }) => theme.spacing['4XL']};
  }

  &::after {
    content: '';
    height: 4px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-color: ${({ theme }) => theme.colors.primary};
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    transition: 0.3s;
    transform: scale(0, 1);
  }

  a {
    color: inherit;
  }

  ${({ isActive, theme }) =>
    isActive
      ? `
    color: ${theme.colors.primary};

    &::after {
      transform: scale(1, 1);
    }
  `
      : ''}
`

export const TabContentWrapper = styled.div``

export const QuoteBox = styled.div`
  margin-top: ${({ theme }) => theme.spacing['7XL']};
  margin-bottom: 36px;
  position: relative;
  padding: ${({ theme }) => theme.spacing['3XL']} ${({ theme }) => theme.spacing['5XL']};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.gray100};
  text-align: center;
  white-space: pre-wrap;
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${Fonts.weight.medium};

  &::before,
  &::after {
    font-family: 'icons-indiedish' !important;
    font-size: 24px;
    color: ${({ theme }) => theme.colors.gray300};
    position: absolute;
  }

  &::before {
    content: '\\e930';
    top: -${({ theme }) => theme.spacing.L};
    left: -${({ theme }) => theme.spacing['3XS']};
  }

  &::after {
    content: '\\e931';
    left: -${({ theme }) => theme.spacing['3XS']};
    bottom: -${({ theme }) => theme.spacing.L};
  }
`

export const SectionDetail = styled.div`
  margin-bottom: 30px;
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }
`

export const DetailContent = styled.div`
  width: calc(100% - 38px);
`

export const DetailTitle = styled(Fonts.H2)`
  color: ${({ theme }) => theme.colors.element.black};
  margin-bottom: ${({ theme }) => theme.spacing.L};
`

export const DetailSubTitle = styled(Fonts.BaseBold)`
  color: ${({ theme }) => theme.colors.base};
`

export const DetailDeliveryContactPhone = styled(Fonts.BaseBold)`
  color: ${({ theme }) => theme.colors.infoDark};
`

export const DetailText = styled(Fonts.Base)<{ error?: boolean }>`
  color: ${({ theme }) => theme.colors.base};

  .LinesEllipsis {
    line-height: 1.745em;
  }

  ${({ error, theme }) =>
    error
      ? `
    color: ${theme.colors.red700};
  `
      : ''}
`

export const DetailRow = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing['XS']};
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }
`

export const DetailCol = styled.div`
  &:first-child {
    min-width: ${({ theme }) => theme.spacing['11XL']};
  }
`

export const FeatureCards = styled.div`
  width: 100%;
`

export const SlideWrapperFeatures = styled.div`
  width: calc(100% + 40px) !important;
  margin-left: -${({ theme }) => theme.spacing['3XL']};
  white-space: nowrap;
`

export const FeatureCard = styled.div<{ video: boolean }>`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing['XS']};
  margin-bottom: ${({ theme }) => theme.spacing.L};
  width: 65%;
  margin-right: ${({ theme }) => theme.spacing.XL};
  display: inline-flex;
  border-radius: ${({ theme }) => theme.radius.xl};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  scroll-snap-align: start;
  box-shadow: ${shadow.heavey};

  @media (${media.screenMdMin}) {
    scroll-snap-align: inherit;
  }

  &:first-child {
    margin-left: ${({ theme }) => theme.spacing['3XL']};
  }

  &::before {
    content: '';
    display: block;
    padding-top: 57%;
  }

  ${({ video }) =>
    video
      ? `
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: black;
      opacity: 0.1;
    }
  `
      : ''}
`

export const SlideWrapper = styled.div`
  width: calc(100% + 78px) !important;
  margin-left: -58px;
  margin-bottom: -${({ theme }) => theme.spacing['3XL']};
  padding-bottom: ${({ theme }) => theme.spacing.XL};
  padding-top: ${({ theme }) => theme.spacing.XL};
`

export const GalleryRow = styled.div`
  white-space: nowrap;
  padding-left: 58px;
`

export const GalleryCol = styled.div`
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing.XL};
  vertical-align: top;

  &:last-child {
    margin-right: ${({ theme }) => theme.spacing['3XL']};
  }
`

export const GalleryItem = styled.div<{ lg: boolean; xlg: boolean; video: boolean }>`
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing.L};
  width: 82px;
  height: 82px;
  border-radius: 10px;
  background-color: gray;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ lg }) =>
    lg
      ? `
    margin-bottom: 0;
    width: 140px;
    height: 180px;
    `
      : ''}

  ${({ xlg }) =>
    xlg
      ? `
    margin-bottom: 0;
    width: 280px;
    height: 180px;
    `
      : ''}

  ${({ video }) =>
    video
      ? `
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: black;
      opacity: .1;
    }
    `
      : ''}
`

export const BtnPlayWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

export const ProductListWrapper = styled.div`
  // margin-top: -40px;
`

export const AboutContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.S};
`

export const ProductContainer = styled.div``

export const PreloadImage = styled.img`
  display: none;
`

export const OverlayPage = styled.div<{ fromLeft: boolean; show: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.element.white};
  transform: translate3d(100%, 0, 0);
  transition: 0.3s;
  pointer-events: none;
  visibility: hidden;

  ${({ fromLeft }) =>
    fromLeft &&
    `
    transform: translate3d(-100%, 0, 0);
  `}

  ${({ show }) =>
    show &&
    `
    visibility: visible;
    pointer-events: auto;
    transform: translate3d(0, 0, 0);
  `}
`

export const BgWhiteFloat = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 78px;
  background-color: ${({ theme }) => theme.colors.element.white};
  z-index: 1;
`

export const HeaderTabs = styled.div<{ isListScheduleContentMode: boolean; isOverlay: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.element.white};
  padding-top: 3px;
  padding-bottom: ${({ isListScheduleContentMode }) => (isListScheduleContentMode ? '5px' : '12px')};
  z-index: 100;

  ${({ isListScheduleContentMode }) =>
    isListScheduleContentMode
      ? `
    padding-bottom: 5px;
  `
      : `
    padding-bottom: 12px;
  `}

  ${({ isOverlay }) =>
    isOverlay &&
    `
    box-shadow: 0 1px 6px rgba(0, 0, 0, .15);
  `}

  ${Container} {
    position: relative;
    display: flex;
  }
`

export const HeaderWrapperInCover = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.element.white};
  z-index: 100;
`

export const SwitchTabsWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 53px;
  margin-left: -${({ theme }) => theme.spacing.S};
  position: relative;
  top: 3px;
`

export const HeaderTab = styled.div<{ noPaddingLeft: boolean; borderRight: boolean }>`
  position: relative;
  top: 2px;
  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing.L};
  min-height: 53px;
  flex: 1;
  color: ${({ theme }) => theme.colors.secondary};

  &:first-child {
    padding-left: 5px;
  }

  ${({ noPaddingLeft }) =>
    noPaddingLeft &&
    `
    padding-left: 0 !important;
  `}

  ${({ borderRight, theme }) =>
    borderRight &&
    `
    &::after {
      content: '';
      width: 1px;
      background-color: ${theme.colors.lightGrey};
      position: absolute;
      right: 0;
      top: ${theme.spacing['3XS']};
      bottom: ${theme.spacing['3XS']};
    }
  `}
`

export const HeaderIconWrapper = styled.div`
  position: relative;
  top: 4px;
  margin-right: ${({ theme }) => theme.spacing.XS};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;

  i {
    color: ${({ theme }) => theme.colors.secondary};
  }
`

export const HeaderTabContent = styled.div`
  padding-top: 5px;
`

export const HeaderTopic = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.secondary};
`

export const HeaderTopicDarkGrey = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.darkGrey};
`

export const HeaderDes = styled(Fonts.ActionBaseBold)<{ float?: boolean; primary?: boolean; orange?: boolean }>`
  color: ${({ theme, primary, orange }) =>
    primary ? theme.colors.primary : orange ? theme.colors.volcano600 : theme.colors.gray900};
  white-space: nowrap;
  max-width: 130px;
  text-overflow: ellipsis;
  overflow: hidden;

  ${({ float }) =>
    float &&
    `
    max-width: 220px;

    @media (${media.screenXsMax}) {
      max-width: 160px;
    }
  `}

  @media (${media.screenXsMax}) {
    font-size: 13px;
  }
`

export const VendorContentWrapper = styled.div<{
  isListScheduleContentMode: boolean
  pickupLayout: boolean
  show: boolean
}>`
  opacity: 0;
  padding-top: 60px;
  margin-bottom: -20px;

  ${({ isListScheduleContentMode, pickupLayout }) =>
    !isListScheduleContentMode && pickupLayout
      ? `
    padding-top: 111px;
  `
      : ''}

  ${({ isListScheduleContentMode, pickupLayout }) =>
    isListScheduleContentMode && !pickupLayout
      ? `
    padding-top: 13px;
  `
      : ''}

  ${({ show }) =>
    show &&
    `
    opacity: 1;
  `}
`

export const StyleLink = styled(Fonts.ActionBaseBold)`
  text-align: center;

  a {
    color: ${({ theme }) => theme.colors.primary};
  }

  span {
    color: ${({ theme }) => theme.colors.primary};
    margin: 0 ${({ theme }) => theme.spacing.S};
  }

  .no-touch &:hover,
  .touch &:active {
    a {
      color: ${({ theme }) => theme.colors.primaryHover};
    }
  }
`

export const TextOutOfDelivery = styled.span`
  color: ${({ theme }) => theme.colors.red100};
`

export const IconArrow = styled((props) => <Icon {...props} />)`
  font-size: 14px;
  color: ${(props) => props.theme.colors.primary};
  position: relative;
  top: 5px;
`

export const IconArrowWrapper = styled.div`
  align-self: center;
  margin-left: auto;
`

export const IconArrowLeftWrapper = styled.div`
  align-self: center;
  margin-right: ${({ theme }) => theme.spacing.S};
`

export const ButtonBackToChooseStoreWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.S} 0;
  margin-bottom: -4px;
  color: ${({ theme }) => theme.colors.primary};

  ${HeaderTabContent} {
    position: relative;
    top: 2px;
  }
`

export const AppVersion = styled.div`
  padding-top: ${({ theme }) => theme.spacing.S};
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSize.lg};
`

export const FooterPoweredByHato = styled.div`
  margin-top: ${({ theme }) => theme.spacing['3XL']};
  border-top: 1px solid #eeeeee;
  padding: ${({ theme }) => theme.spacing['3XL']} 0;
  display: flex;
  justify-content: center;
`
